<template>
  <ShareModal
      :show-modal="modalVisible"
      :url="shareUrl"
      body="E-Lux%20Kodutehnika%20võrdlus%20&body=Saadan%20sulle%20tootevõrdluse%20vaatamiseks%3A%20"
      @close="modalVisible = false"
  />
  <div
      v-if="compares.length > 0"
      class="bg-white border-t border-t-gray-300 fixed print:static bottom-0 left-0 right-0 z-30 w-full overflow-y-hidden print:overflow-visible transition-transform transform-none"
      tabindex="-1"
      aria-labelledby="drawer-bottom-label">
    <div class="bg-secondary-500 p-2 print:bg-white">
      <div
          class="print:hidden container cursor-pointer max-w-screen-1.5xl mx-auto px-4 lg:px-8 flex justify-between text-white"
          @click="toggleCompare"
      >
        <div class="font-semibold ml-20">
          {{ __("Võrdlus") }} ({{ compares.length }})
        </div>
        <button
            class="mr-20"
            type="button"
            data-drawer-hide="drawer-bottom-example"
            aria-controls="drawer-bottom-example"
        >
          <ChevronUpIcon v-if="visible" class="w-6 h-6"/>
          <ChevronDownIcon v-else class="w-6 h-6"/>
          <span class="sr-only">{{ __("Sulge menüü") }}</span>
        </button>
      </div>
    </div>
    <div class="container max-w-screen-1.5xl mx-auto px-4 lg:px-8">
      <div
          v-if="visible"
          class="overflow-auto h-[80vh] lg:h-[90vh] print:overflow-x-visible print:h-full"
      >
        <div class="flex justify-between items-center">
          <h1 class="text-2xl py-4 pr-2">{{ __("Võrdlus") }}</h1>
          <div class="print:hidden space-x-2 space-y-2 mr-10">
            <a
                href="#"
                class="hidden lg:inline-flex btn btn-outline btn-sm"
                onclick="window.print();"
            >
              {{ __("Prindi") }}
              <PrinterIcon class="w-4 h-4"/>
            </a>
            <a
                class="btn btn-outline btn-sm"
                target="_blank"
                rel="nofollow"
                :href="trRoute('pdf.compare', { ids: compareIds })"
            >
              PDF
              <DocumentIcon class="w-4 h-4"/>
            </a>
            <a
                class="btn btn-outline btn-sm"
                href="#"
                @click.prevent="showModal"
            >
              {{ __("Jaga") }}
              <ShareIcon class="w-4 h-4"/>
            </a>
          </div>
        </div>
        <table class="table table-fixed">
          <tbody>
          <tr class="print:hidden">
            <th class="w-32"></th>
            <td v-for="(product, idx) in compares" :key="idx" class="w-40 text-center">
              <a
                  href="#"
                  class="btn btn-sm btn-error btn-outline compare-remove"
                  :class="'product-' + product.id"
                  @click.prevent="remove(product.id)"
              >
                {{ __("Eemalda võrdlusest") }}
              </a>
            </td>
          </tr>
          <tr>
            <th></th>
            <td v-for="(product, idx) in compares" :key="idx">
              <Link
                  :href="
                    trRoute('product', { product: trField(product, 'url') })
                  "
              >
                <ProductPicture
                    :key="product.id"
                    classes="mx-auto w-fit"
                    :image="product.filename"
                    :title="product.title"
                    size="235"
                />
              </Link>

            </td>
          </tr>
          <tr>
            <th></th>
            <td v-for="(product, idx) in compares" :key="idx" class="text-center">
              <Link
                  class="text-lg lg:text-xl"
                  :href="
                    trRoute('product', { product: trField(product, 'url') })
                  ">
                {{ trField(product, "title") }}
              </Link>
            </td>
          </tr>
          <tr>
            <th></th>
            <td v-for="(product, idx) in compares" :key="idx" class="text-center">
              {{ product.code }}
            </td>
          </tr>
          <tr class="print:hidden">
            <th></th>
            <td v-for="(product, idx) in compares" :key="idx" class="text-center">
              <a
                  href="#"
                  class="add-to-cart btn btn-primary"
                  :class="'product-' + product.id"
                  :data-product="product.id"
                  @click.prevent="addToCart(product)"
              >
                {{ __("Lisa ostukorvi") }}
              </a>
            </td>
          </tr>
          <tr>
            <th>{{ __("Hind") }}</th>
            <td v-for="(product, idx) in compares" :key="idx" class="text-center">
              <ProductPrice
                  classes="text-center"
                  :good-price="product.good_price"
                  :price-vat="product.price_vat"
                  :price-default-vat="product.price_default_vat"
                  :discount-end="product.discount_end"
                  :discount-start="product.discount_start"
                  :show-installment="false"
              />
            </td>
          </tr>
          <tr v-for="(nameField, code) in uniqueFields" :key="code">
            <th>
              {{ trField(nameField, "name") }}
            </th>
            <template v-for="(product, idx) in compares" :key="idx">
              <template v-for="(field, idx2) in product.fields" :key="idx2">
                <td v-if="field.code === code" class="text-center">
                  <FieldValue :field="field" classes="mx-auto"/>
                </td>
              </template>
              <td v-if="notHasForProduct(product.fields, code)">
                &nbsp;
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {__, toCart, trField, trRoute} from "../utils";
import {Link, router, usePage} from "@inertiajs/vue3";
import {computed, ref} from "vue";
import {ChevronDownIcon, ChevronUpIcon, DocumentIcon, PrinterIcon, ShareIcon} from "@heroicons/vue/24/solid";
import FieldValue from "../components/FieldValue.vue";
import ProductPrice from "../components/ProductPrice.vue";
import ProductPicture from "../components/ProductPicture.vue";
import ShareModal from "./ShareModal.vue";

const visible = ref(false);
const page = usePage();
const shareUrl = trRoute("compare", {
  ids: page.props.compares.map((compare) => compare.id).join(",")
});
const modalVisible = ref(false);
const showModal = () => (modalVisible.value = true);
const toggleCompare = () => (visible.value = !visible.value);
const compares = computed(() => page.props.compares);
const compareIds = computed(() => compares.value.map((compare) => compare.id));
const addToCart = (product) => toCart({id: product.id, show_modal: true});
const remove = (id) => router.delete(trRoute("compare.remove", {id}));
const notHasForProduct = (fields, fieldCode) => {
  const hasField = fields.filter((fl) => {
    return fl.code === fieldCode;
  });
  return hasField.length === 0;
};
const uniqueFields = computed(() => {
  let uniques = {};
  compares.value &&
  compares.value
      .map((product) => product.fields)
      .forEach((fields) => {
        fields &&
        fields.forEach((field) => {
          uniques[field.code] = {
            name: field.name,
            name_ru: field.name_ru
          };
        });
      });
  return uniques;
});
</script>
